import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { useClickStopPropagationRef } from 'custom_hooks/useClickStopPropagationRef';
import { usePopup } from 'custom_hooks/usePopup';
import { ReactNode } from 'react';
import { TriggeredPopup } from 'shared/triggered_popup/TriggeredPopup';
import styled from 'styled-components';
import { stopEvent } from 'utils/event';

const ContentContainer = styled.div`
    max-width: 30rem;
    font-size: 1.4rem;
`;

const StyledTriggeredPopup = styled(TriggeredPopup)`
    border: 1px solid var(--border-default);
`;

type InfoPopupProps = {
    title: string;
    triggerClassName?: string;
    children: ReactNode;
    type?: 'info' | 'error';
};

export function InfoPopup({ title, triggerClassName, children, type }: InfoPopupProps) {
    const { triggerRef, popupRef, isOpen, toggleOpen, close } = usePopup({
        closeOnClickOutside: true,
    });
    const contentRef = useClickStopPropagationRef<HTMLDivElement>();

    const isErrorType = type === 'error';

    return (
        <>
            <HoverIconButton
                ref={triggerRef}
                title={title}
                ariaLabel={title}
                icon={isErrorType ? faExclamationCircle : faInfoCircle}
                hoverIcon={isErrorType ? faExclamationCircle : faInfoCircle}
                color={isErrorType ? 'var(--error-default)' : 'var(--text-secondary)'}
                hoverColor={isErrorType ? 'var(--error-hover)' : 'var(--text-link)'}
                onClick={(e) => {
                    stopEvent(e);
                    toggleOpen();
                }}
                className={triggerClassName}
            />
            {isOpen && (
                <StyledTriggeredPopup
                    ref={popupRef}
                    anchorRef={triggerRef}
                    onClose={close}
                    test-id="InfoPopup__Popup"
                >
                    <ContentContainer ref={contentRef}>{children}</ContentContainer>
                </StyledTriggeredPopup>
            )}
        </>
    );
}
